/**
 * @Module: Logging Utility
 * @Status: Ready
 * @Summary: Provides logging functionality for frontend
 * @Description: Browser-compatible logging with localStorage persistence
 * @NextSteps: Add log rotation for localStorage
 */

interface LogEntry {
	timestamp: string;
	level: string;
	message: string;
}

const MAX_STORED_LOGS = 1000;
const STORAGE_KEY = 'choppy_frontend_logs';

const formatLogMessage = (level: string, message: string): string => {
	const timestamp = new Date().toISOString();
	return `${timestamp} [${level.toUpperCase().padEnd(7)}] ${message}`;
};

const storeLog = (entry: LogEntry): void => {
	try {
		const storedLogs = localStorage.getItem(STORAGE_KEY);
		const logs: LogEntry[] = storedLogs ? JSON.parse(storedLogs) : [];
		
		logs.push(entry);
		
		// Keep only the latest logs
		if (logs.length > MAX_STORED_LOGS) {
			logs.splice(0, logs.length - MAX_STORED_LOGS);
		}
		
		localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
	} catch (error) {
		// Fail silently if localStorage is not available
		console.warn('Failed to store log in localStorage');
	}
};

const createLogEntry = (level: string, message: string): LogEntry => ({
	timestamp: new Date().toISOString(),
	level,
	message
});

export const util_log_debug_01 = (message: string): void => {
	const entry = createLogEntry('debug', message);
	console.debug(formatLogMessage(entry.level, entry.message));
	storeLog(entry);
};

export const util_log_info_01 = (message: string): void => {
	const entry = createLogEntry('info', message);
	console.info(formatLogMessage(entry.level, entry.message));
	storeLog(entry);
};